<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Remove Promotion</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="container my-4">
            <div class="row">
                <div class="col-12 ">
                    <span class="title_header_bar">Genrate Promotion Excel</span>
                </div>
            </div>
            <div class="card card_content">
                <form [formGroup]="form">
                    <div class="row mx-3">
                        <div class="col-xl-6 ">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Promo Code</mat-label>
                                <mat-select class="scrollbarcs" formControlName="promoId"
                                    placeholder="Please Select promocode">
                                    <mat-select-filter [displayMember]="'value'" [array]="promocodelist"
                                        (filteredReturn)="filteredList = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Promotion End Month</mat-label>
                                <input readonly matInput [matDatepicker]="startDate" id="startDate"
                                    formControlName="month" autocomplete="off" placeholder="Billing Period Month"
                                    class="col-12 custom-input-border" specialIsAlphaNumeric
                                    (click)="startDate.open()" style="color:black;" [min]="minDate">
                                <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke="currentColor">

                                        </svg>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDate startView="multi-year"
                                    (monthSelected)="setMonthAndYear($event, startDate)"
                                    panelClass="example-month-picker">
                                </mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-12 mt-4 d-flex justify-content-center">
                            <button class="btn reset_btn  mr-3 btn_danger" (click)="reset()">
                                <i class="fa fa-refresh mr-2"></i>Reset
                            </button>
                            <button class="btn btn-primary" (click)="GetExcel()">
                                <i class="fa fa-file-excel mr-2"></i>Generate Excel
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="container my-4">
            <div class="row">
                <div class="col-12 ">
                    <span class="title_header_bar">Upload Excel</span>
                </div>
            </div>
            <div class="card card_content">
                <form [formGroup]="attachmentform">
                    <div class="row mx-3 justify-content-center">
                        <div class="col-7">
                            <div class="padd-right-file" style="display: flex;">
                                <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                                    <mat-label>Attachment</mat-label>
                                    <input matInput id="AttachmentFileName" placeholder="Select Attachment"
                                        formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                        class="col-10" autocomplete="off" readonly>
                                </mat-form-field>
                                <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg"
                                        style="width: 26px;" />
                                </button>
                                <button type="button" (click)="remove()" *ngIf="isFileSelected"
                                    class="badge bg-light-blue image-button">
                                    <img style="filter: invert(1);width: 26px;"
                                        src="../../../../assets/Home-Connect/icons/delete.svg" />
                                </button>
                            </div>

                        </div>
                        <div class="col-xl-12 mt-4 d-flex justify-content-center">
                            <button class="btn btn-primary mr-3" (click)="upload()">
                                <i class="fa fa-file-excel mr-2"></i>Upload Excel
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>